
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { Funder } from '@/types/funder';

@Component
export default class FunderMetaDataInput extends Vue {
  @Prop() funder!: Funder;

  @Mutation('funders/setFunderNoIndex') setFunderNoIndex!: Function;
  @Mutation('funders/setFunderMetaTitle') setFunderMetaTitle!: Function;
  @Mutation('funders/setFunderMetaDescription')
  setFunderMetaDescription!: Function;
  @Mutation('funders/setFunderCanonicalUrl') setFunderCanonicalUrl!: Function;
  @Mutation('funders/setFunderTwitterTitle') setFunderTwitterTitle!: Function;
  @Mutation('funders/setFunderTwitterDescription')
  setFunderTwitterDescription!: Function;
  @Mutation('funders/setFunderOpenGraphTitle')
  setFunderOpenGraphTitle!: Function;
  @Mutation('funders/setFunderOpenGraphDescription')
  setFunderOpenGraphDescription!: Function;

  get noindex() {
    return this.funder.meta!.noindex;
  }
  set noindex(value) {
    this.setFunderNoIndex(value);
  }
  get meta_title() {
    return this.funder.meta!.meta_title;
  }
  set meta_title(value) {
    this.setFunderMetaTitle(value);
  }
  get meta_description() {
    return this.funder.meta!.meta_description;
  }
  set meta_description(value) {
    this.setFunderMetaDescription(value);
  }
  get canonical_url() {
    return this.funder.meta!.canonical_url;
  }
  set canonical_url(value) {
    this.setFunderCanonicalUrl(value);
  }

  get twitter_title() {
    return this.funder.meta!.twitter_title;
  }
  set twitter_title(value) {
    this.setFunderTwitterTitle(value);
  }
  get twitter_description() {
    return this.funder.meta!.twitter_description;
  }
  set twitter_description(value) {
    this.setFunderTwitterDescription(value);
  }

  get open_graph_title() {
    return this.funder.meta!.open_graph_title;
  }
  set open_graph_title(value) {
    this.setFunderOpenGraphTitle(value);
  }
  get open_graph_description() {
    return this.funder.meta!.open_graph_description;
  }
  set open_graph_description(value) {
    this.setFunderOpenGraphDescription(value);
  }
}
